import { endpoints } from "@/config/endpoints";
import { apiService } from "@/services/apiService";

export default {
  getTag(id) {
    return apiService.get(endpoints.companyTag(id));
  },
  getTags() {
    return apiService.get(endpoints.companyTags, { params: { type: "PLACE" } }); // remove after feat/CN-5561_categories-per-source merge
  },

  addTag(name) {
    return apiService.post(endpoints.companyTags, { name, type: "PLACE" }); // remove after feat/CN-5561_categories-per-source merge
  },

  editTag(id, payload) {
    return apiService.patch(endpoints.companyTag(id), payload);
  },

  removeTag(id) {
    return apiService.delete(endpoints.companyTag(id), {
      data: { type: "PLACE" }
    }); // remove after feat/CN-5561_categories-per-source merge
  }
};
